import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from '../Icons/IconWithText';
import Button from '../Buttons/Button';

const FavouriteButton = ({ favourited, iconFill, ...rest }) => {
  const unfavouriteText = 'Unfavourite';
  const favouriteText = 'Favourite';

  const favouriteBtnInner = <IconWithText name="favourite" size="m" fill={iconFill}>{favouriteText}</IconWithText>;
  const unfavouriteBtnInner = <IconWithText name="favourite" size="m" fill="red">{unfavouriteText}</IconWithText>;

  let favouriteButton;
  if (favourited === true) {
    favouriteButton = (
      <Button {...rest} classes="favourite-btn favourited" faux>{unfavouriteBtnInner}</Button>
    );
  } else {
    favouriteButton = (
      <Button {...rest} classes="favourite-btn" faux>{favouriteBtnInner}</Button>
    );
  }

  return favouriteButton;
};

FavouriteButton.propTypes = {
  favourited: PropTypes.bool.isRequired,
  iconFill: PropTypes.string,
};

export default FavouriteButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/FavouriteButton.js